<template>
  <div class="navbartop">
    <nav class="row div-navbar-color">
      <div class="col-xl-6 col-lg-6 col-md-8 col-sm-6 col-6 div-navbar menu">
        <b-sidebar
          v-show="sidebarIsVisible"
          id="menu"
          shadow
          backdrop
          @shown="retrieve"
        >
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0">
            <div class="header-sidebar modern-header pb-4" slot="header">
              <div
                class="modern-close-button"
                @click="sidebarIsVisible = false"
                v-b-toggle.menu
              >
                <i class="fas fa-times"></i>
              </div>

              <img
                class="sidebar-img-logo"
                :src="require('../assets/logo.png')"
              />
              <h1 class="name-system-menu modern-title mb-0">
                {{ rest_home_fantasy_name }}
              </h1>
            </div>
            <nav id="sidebar" v-if="$store.state.online" class="modern-sidebar">
              <ul class="list-unstyled pl-0">
                <li
                  v-if="
                    rest_home_finance == 0 &&
                    !permission('read', 'only_financial')
                  "
                  class="modern-menu-item"
                >
                  <a
                    @click="handlePage('dashboard')"
                    class="modern-link home-link"
                  >
                    <i class="fas fa-home modern-icon"></i>
                    <span class="modern-text">Dashboard</span>
                  </a>
                </li>
                <li v-if="rest_home_finance == 0" class="modern-menu-item">
                  <a @click="handleToModules" class="modern-link modules-link">
                    <i class="fas fa-plus-circle modern-icon"></i>
                    <span class="modern-text">Conheça nossos módulos</span>
                  </a>
                </li>
                <li
                  v-show="terms == 1"
                  v-for="(i, k) in routesItems"
                  :key="k"
                  :class="['modern-menu-item', current == k && 'active-item']"
                >
                  <a
                    :href="`#menu_${k}`"
                    data-toggle="collapse"
                    :aria-expanded="current == k ? true : false"
                    :class="[
                      'modern-link dropdown-toggle-modern',
                      current == k && 'collapsed-modern',
                    ]"
                  >
                    <i :class="[i.iconClass, 'modern-icon']"></i>
                    <span class="modern-text">{{ i.title }}</span>
                    <i
                      class="fas fa-chevron-down modern-arrow"
                      :class="{ rotated: current == k }"
                    ></i>
                  </a>
                  <ul
                    v-for="(y, j) in i.routes"
                    :key="j"
                    :class="[
                      'collapse list-unstyled modern-submenu',
                      current == k && 'show',
                    ]"
                    :id="`menu_${k}`"
                  >
                    <li
                      v-for="(x, z) in y.routes"
                      :key="z"
                      v-show="x.show"
                      class="modern-submenu-item"
                    >
                      <a
                        :class="[
                          'modern-sublink',
                          route == x.name && 'route-active-modern',
                        ]"
                        @click="handlePage(`${x.name}`, k)"
                      >
                        <i :class="[x.iconClass, 'modern-subicon']"></i>
                        <span class="modern-subtext">{{ x.description }}</span>
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </nav>
            <div v-if="!$store.state.online" class="offline-section">
              <a
                @click="$router.push({ name: 'dashboard' })"
                class="modern-link home-link"
              >
                <ul class="list-unstyled pl-0">
                  <li class="modern-menu-item p-2">
                    <i class="fas fa-home modern-icon"></i>
                    <span class="modern-text">HOME</span>
                  </li>
                </ul>
              </a>
              <div class="text-center offline-info">
                <h6 class="offline-title">Sistema em modo offline!</h6>
                <h6 class="offline-subtitle">ACESSOS DISPONÍVEIS:</h6>
                <div class="offline-list">
                  <p class="offline-item">Aba Saúde (Sinais Vitais)</p>
                  <p class="offline-item">Aba Rotina Diária (Todas as abas)</p>
                </div>
                <div class="offline-warning">
                  <p class="offline-warning-text">
                    Não é possível inserir novas informações.
                  </p>
                  <p class="offline-warning-text">
                    Banco de dados inacessível.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </b-sidebar>
        <button
          v-if="dashboard_monitoring == 0"
          v-b-toggle.menu
          @click="handleSidebar"
          class="btn-menu-sidebar enhanced-menu-btn"
        >
          <i class="fas fa-bars span-icon" width="20"></i>
        </button>
        <h1
          class="name-clinic enhanced-clinic-name"
          @click="
            () => {
              if ($router.currentRoute.name == 'dashboard') $router.go(0);
              else $router.push({ name: 'dashboard' });
            }
          "
        >
          {{ rest_home_fantasy_name }}
        </h1>
      </div>
      <div
        class="col-xl-6 col-lg-6 col-md-4 col-sm-6 col-6 div-navbar account enhanced-account-section"
      >
        <SystemUpdate />

        <!-- Botão de notificação: -->
        <div
          class="dropdown d-inline-block modern-notification-dropdown enhanced-notification"
        >
          <a
            type="button"
            class="notification-menu enhanced-notification-btn"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="fas fa-bell"></i>
            <span
              v-if="docsToReadUser.length > 0 || buysToBeMade.length > 0"
              class="notification-alert-badge enhanced-badge"
            ></span>
          </a>

          <div
            class="dropdown-menu dropdown-menu-right dropdown-notification modern-notification-menu enhanced-notification-menu"
          >
            <div class="notification-header enhanced-notification-header">
              <i class="fas fa-bell notification-doc-icon"></i>

              <span class="notification-title">Notificações</span>
            </div>

            <div
              v-if="docsToReadUser.length"
              class="notification-list enhanced-notification-list"
            >
              <span class="notification-list-label"
                >Documentos para verificar:</span
              >

              <div
                v-for="doc in docsToReadUser"
                :key="doc.id"
                class="notification-item enhanced-notification-item"
              >
                <div class="notification-doc-info">
                  <div class="notification-doc-info-header">
                    <i class="fas fa-file-alt notification-doc-icon"></i>

                    <span class="notification-doc-name">{{
                      doc.doc_name
                    }}</span>
                  </div>
                </div>

                <button
                  class="btn btn-sm btn-primary notification-action-btn enhanced-action-btn"
                  @click="handleDoc(doc)"
                >
                  <i class="fas fa-eye mr-1"></i>
                  Verificar
                </button>
              </div>
            </div>

            <div
              v-if="buysToBeMade.length"
              class="notification-list enhanced-notification-list"
            >
              <span class="notification-list-label"
                >Listas de compras aguardando finalização:</span
              >

              <div
                v-for="buy in buysToBeMade"
                :key="buy.id"
                class="notification-item enhanced-notification-item"
              >
                <div class="notification-doc-info">
                  <div class="notification-doc-info-header">
                    <i class="fas fa-file-alt notification-doc-icon"></i>

                    <span class="notification-doc-name">{{ buy.name }}</span>
                  </div>

                  <span v-if="buy.date_be_made" class="notification-doc-date">
                    Data para a compra:
                    {{ formatDate(buy.date_be_made, false) }}
                  </span>
                </div>

                <v-btn
                  class="btn btn-sm btn-primary notification-action-btn enhanced-action-btn"
                  small
                  @click="directToPrintViewBuy(buy.id)"
                >
                  <i class="fas fa-print mr-1"></i>
                  Imprimir
                </v-btn>
              </div>
            </div>

            <div
              v-if="docsToReadUser.length == 0 && buysToBeMade.length == 0"
              class="notification-empty enhanced-notification-empty"
            >
              <span class="notification-list-label">Sem notificações</span>
            </div>
          </div>
        </div>

        <ConfirmationReading
          @reload="reloadPage"
          :docsToRead="docToRead"
          :onClose="true"
        />

        <h6
          class="offline-alert enhanced-offline-alert"
          v-if="!$store.state.online"
        >
          OFFLINE <br />
          {{ last_offline_update }}
        </h6>

        <v-btn
          class="btn btn-help-menu enhanced-help-btn"
          small
          @click="handleToHelp"
          v-if="$store.state.online"
        >
          <i class="fas fa-question mr-2"></i> AJUDA
        </v-btn>
        <v-btn
          v-if="system_update && system_update.status == 1"
          class="btn-acess system-update enhanced-update-btn"
          small
          @click="$bvModal.show('system-update')"
        >
          <i class="fas fa-sync-alt mr-2"></i> ATUALIZAÇÃO
        </v-btn>
        <div
          :class="[
            'div-photo-url-top enhanced-photo-container',
            $store.state.online ? 'online' : 'offline',
          ]"
        >
          <img
            v-if="!user.photo_url"
            :src="require('../assets/user.svg')"
            class="photo-top-user secondary"
          />
          <img
            v-if="user.photo_url"
            :src="user.photo_url"
            class="photo-top-user"
          />
        </div>
        <h6 class="user-name-menu enhanced-user-name">
          {{ String(user.name).split(" ")[0] }}
        </h6>
        <div
          class="dropdown d-inline-block modern-user-dropdown enhanced-user-dropdown"
        >
          <a
            type="button"
            class="dropdown-toggle access-settings enhanced-settings-btn"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
          </a>
          <div
            class="dropdown-menu dropdown-menu-right modern-user-menu enhanced-user-menu"
          >
            <button
              v-if="width <= 575"
              class="dropdown-item username-mobile modern-user-item enhanced-user-item"
              type="button"
            >
              <i class="fas fa-user-circle mr-2 user-icon-mobile"></i>
              {{ String(user.name).split(" ")[0] }}
            </button>
            <button
              v-if="$store.state.online"
              @click="handleToAccount"
              class="dropdown-item modern-user-item enhanced-user-item"
              type="button"
            >
              <i class="fas fa-user-circle mr-2"></i>
              Minha conta
            </button>
            <button
              @click="logout"
              class="dropdown-item modern-user-item logout-btn enhanced-user-item enhanced-logout"
              type="button"
            >
              <i class="fas fa-sign-out-alt mr-2"></i>
              Sair
            </button>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import ConfirmationReading from "../templates/DocsFolder/ConfirmationReading";
import SystemUpdate from "./Account/SystemUpdate";

import { get } from "idb-keyval";
import { userData } from "../lib/functions";
import permission from "../lib/permission";
import routes from "../routes";
import api from "../services/api";
import moment from "moment";
import { formatDate } from "../lib/format";

export default {
  name: "NavBar",

  components: {
    SystemUpdate,
    ConfirmationReading,
  },

  data() {
    return {
      docToRead: null,

      docsToReadUser: [],

      buysToBeMade: [],

      last_offline_update: "",

      accessed_offline: false,

      user: {},

      current: null,

      route: null,

      sidebarIsVisible: true,

      routesItems: [],

      rest_home_fantasy_name: "",

      system_update: undefined,

      width: window.screen.width,

      rest_home_finance: 0,
      dashboard_monitoring: 0,

      terms: 1,
    };
  },

  created() {
    this.getFantasyName();

    this.getDocsToRead();

    this.getBuysToBeMade();

    this.getOfflineLastUpdate();

    this.retrieve();

    window.addEventListener("resize", this.handleOnResize);

    this.handleOnResize();
  },

  destroyed() {
    window.removeEventListener("resize", this.handleOnResize);
    this.handleOnResize();
  },

  methods: {
    permission,
    formatDate,

    async getFantasyName() {
      try {
        const user = await get("user");
        this.rest_home_fantasy_name = user
          ? user.rest_home_fantasy_name
          : "SISTEMA CLIN";
      } catch {
        this.rest_home_fantasy_name = "SISTEMA CLIN";
      }
    },

    async getDocsToRead() {
      try {
        const response = await api.get("/folder/user/read-doc/all");

        const { docsToReadUser } = response.data;

        if (docsToReadUser) {
          this.docsToReadUser = docsToReadUser;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getBuysToBeMade() {
      try {
        const response = await api.get("/buy/to-made");

        const { buysToBeMade } = response.data;

        if (buysToBeMade) {
          this.buysToBeMade = buysToBeMade;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async retrieve() {
      let { user } = userData();

      if (!user) {
        try {
          await this.logout();
        } catch {
          //catch
        } finally {
          routes.push({ name: "sign-in" });
        }
      }

      let { rest_home_finance, dashboard_monitoring } = user;

      this.user = user;
      this.rest_home_finance = rest_home_finance;

      if (dashboard_monitoring == 1) {
        this.dashboard_monitoring = dashboard_monitoring;
      }

      let accessed_offline = JSON.parse(
        sessionStorage.getItem("accessed_offline") || !this.$store.state.online
      );

      let system_update = sessionStorage.getItem("system_update");
      if (system_update) {
        this.system_update = JSON.parse(system_update);
      }

      this.accessed_offline = accessed_offline;

      this.mountRoutes();
    },

    async getOfflineLastUpdate() {
      const last_offline_update = await get("last-offline-update");
      this.last_offline_update = moment(last_offline_update).format(
        "DD/MM/YYYY HH:mm:ss"
      );
    },

    async logout() {
      try {
        sessionStorage.removeItem("accessed_offline");
        localStorage.removeItem("residents_cached");
        await api.get("/status/logout");
      } catch (error) {
        console.log(error);
      } finally {
        routes.push({ name: "sign-in" });
      }
    },

    handleOnResize() {
      this.width = window.innerWidth;
    },

    handleSidebar() {
      this.sidebarIsVisible = true;
    },

    mountRoutes() {
      let { import_migrations, medicine_one_third } = routes.currentRoute.query;

      let routesItems = [
        {
          title: "Assinatura digital",
          show: permission("read", "bry_sign"),
          iconClass: "fas fa-file-signature",
          routes: [
            {
              routes: [
                {
                  name: "bry",
                  description: "Assinar",
                  show: true,
                  iconClass: "fas fa-file-signature",
                },
              ],
            },
          ],
        },
        {
          title: "Receita digital",
          show: permission("read", "digital_recipe"),
          iconClass: "fas fa-prescription-bottle-alt",
          routes: [
            {
              routes: [
                {
                  name: "digital-recipe",
                  description: "Receita Digital",
                  show: true,
                  iconClass: "fas fa-prescription-bottle-alt",
                },
              ],
            },
          ],
        },
        {
          title: "Responsável Técnico",
          show: permission("read", "technical_responsible"),
          iconClass: "fas fa-user",
          routes: [
            {
              routes: [
                {
                  name: "technical-responsible-my-validations",
                  description: "Minhas validações",
                  show: true,
                  iconClass: "fas fa-user-edit",
                },
              ],
            },
          ],
        },
        {
          title: "Controle de produtos para comprar",
          show: permission("read", "list") || permission("write", "list"),
          iconClass: "fas fa-list",
          routes: [
            {
              routes: [
                {
                  name: "lists",
                  description: "Listas de produtos",
                  show: permission("read", "list"),
                  iconClass: "fas fa-list",
                },
                {
                  name: "answer-lists",
                  description: "Responder listas",
                  show: permission("write", "list"),
                  iconClass: "fas fa-pen",
                },
              ],
            },
          ],
        },
        {
          title: "Agenda",
          show: permission("read", "schedule"),
          iconClass: "fas fa-calendar",
          routes: [
            {
              routes: [
                {
                  name: "schedule",
                  description: "Calendário",
                  show: true,
                  iconClass: "fas fa-calendar",
                },
                {
                  name: "schedule-type",
                  description: "Tipos de Agendamento",
                  show: true,
                  iconClass: "fas fa-calendar-times",
                },
              ],
            },
          ],
        },
        {
          title: "Pasta",
          show: permission("read", "folder"),
          iconClass: "fas fa-folder",
          routes: [
            {
              routes: [
                {
                  name: "folder",
                  description: "Jurídico",
                  show: true,
                  iconClass: "fas fa-folder-open",
                },
              ],
            },
          ],
        },
        {
          title: "Lista de compras",
          show: permission("read", "buy"),
          iconClass: "fas fa-shopping-cart",
          routes: [
            {
              routes: [
                {
                  name: "buy",
                  description: "Ver listas de compras",
                  show: true,
                  iconClass: "fas fa-shopping-bag",
                },
              ],
            },
          ],
        },
        {
          title: "Residentes",
          show:
            permission("read", "resident_health") ||
            permission("read", "resident_daily_routine_medicine_check"),
          iconClass: "fas fa-users",
          routes: [
            {
              routes: [
                {
                  name: "residents-vital-signs-list",
                  description: "Saúde",
                  show: permission("read", "resident_health"),
                  iconClass: "fas fa-list",
                },
                {
                  name: "checks",
                  description: "Checagem de medicamentos",
                  show: permission(
                    "read",
                    "resident_daily_routine_medicine_check"
                  ),
                  iconClass: "fas fa-pills",
                },
              ],
            },
          ],
        },
        {
          title: "Filial",
          show: permission("read", "branch"),
          iconClass: "fas fa-city",
          routes: [
            {
              routes: [
                {
                  name: "branch",
                  description: "Transferência de clientes",
                  show: true,
                  iconClass: "fas fa-exchange-alt",
                },
              ],
            },
          ],
        },
        {
          title: "Médico",
          show: permission("write", "resident_medical_prescription"),
          iconClass: "fas fa-user-md",
          routes: [
            {
              routes: [
                {
                  name: "doctor",
                  description: "Prescrição/Aprazamento",
                  show: true,
                  iconClass: "fas fa-folder",
                },
              ],
            },
          ],
        },
        {
          title: "Semiologia",
          show: permission("read", "semiology"),
          iconClass: "fas fa-th-list",
          routes: [
            {
              routes: [
                {
                  name: "semiology-forms",
                  description: "Formulários",
                  show: true,
                  iconClass: "fas fa-list",
                },
                {
                  name: "resident-answered-semiologies",
                  description: "Formulários respondidos",
                  show: true,
                  iconClass: "fas fa-user-edit",
                },
                {
                  name: "answer-semiologies",
                  description: "Responder formulários",
                  show: true,
                  iconClass: "fas fa-pen",
                },
              ],
            },
          ],
        },
        {
          title: "Cadastro",
          show:
            permission("read", "bed") ||
            permission("read", "type_of_hosting") ||
            permission("read", "resident") ||
            permission("read", "resident_relatives") ||
            permission("read", "provider"),
          iconClass: "fas fa-folder-plus",
          routes: [
            {
              routes: [
                {
                  name: "beds",
                  description: "Leitos",
                  show: permission("read", "bed"),
                  iconClass: "fas fa-bed",
                },
                {
                  name: "types-of-hosting",
                  description: "Tipos de Hospedagens",
                  show: permission("read", "type_of_hosting"),
                  iconClass: "fas fa-th-list",
                },
              ],
            },
            {
              routes: [
                {
                  name: "residents",
                  description: "Residentes",
                  show: permission("read", "resident"),
                  iconClass: "fas fa-users",
                },
                {
                  name: "customers",
                  description: "Familiares",
                  show: permission("read", "resident_relatives"),
                  iconClass: "fas fa-users",
                },
                {
                  name: "providers",
                  description: "Fornecedor",
                  show: permission("read", "provider"),
                  iconClass: "fas fa-user",
                },
              ],
            },
          ],
        },
        {
          title: "Serviços",
          show:
            permission("read", "service_charge_type") ||
            permission("read", "service"),
          iconClass: "fas fa-list-ol",
          routes: [
            {
              routes: [
                {
                  name: "serviceschargetypes",
                  description: "Tipos de cobranças de serviços",
                  show: permission("read", "service_charge_type"),
                  iconClass: "fas fa-file-invoice-dollar",
                },
                {
                  name: "services",
                  description: "Serviços",
                  show: permission("read", "service"),
                  iconClass: "fas fa-th-list",
                },
              ],
            },
          ],
        },
        {
          title: "Usuários",
          show:
            permission("read", "user_group") ||
            permission("read", "user_profile") ||
            permission("read", "user") ||
            permission("read", "permission"),
          iconClass: "fas fa-users",
          routes: [
            {
              routes: [
                {
                  name: "usersgroup",
                  description: "Grupo de usuários",
                  show: permission("read", "user_group"),
                  iconClass: "fas fa-users",
                },
                {
                  name: "usersprofile",
                  description: "Perfil de usuários",
                  show: permission("read", "user_profile"),
                  iconClass: "fas fa-user-circle",
                },
              ],
            },
            {
              routes: [
                {
                  name: "users",
                  description: "Usuários",
                  show: permission("read", "user"),
                  iconClass: "fas fa-users",
                },
                {
                  name: "permissions",
                  description: "Permissões",
                  show: permission("read", "permission"),
                  iconClass: "fas fa-lock-open",
                },
                {
                  name: "devices",
                  description: "Dispositivos",
                  show: permission("read", "devices"),
                  iconClass: "fas fa-desktop",
                },
                {
                  name: "account",
                  description: "Minha Conta",
                  show: true,
                  iconClass: "fas fa-user",
                },
              ],
            },
          ],
        },
        {
          title: "Plantões",
          show: permission("read", "duty"),
          iconClass: "fas fa-briefcase-medical",
          routes: [
            {
              routes: [
                {
                  name: "duty",
                  description: "Gerenciamento",
                  show: permission("read", "duty"),
                  iconClass: "fas fa-cogs",
                },
              ],
            },
          ],
        },
        {
          title: "Medicamentos",
          show: permission("read", "medicine"),
          iconClass: "fas fa-capsules",
          routes: [
            {
              routes: [
                {
                  name: "medicines",
                  description: "Gerenciamento",
                  show: permission("read", "medicine"),
                  iconClass: "fas fa-cogs",
                },
              ],
            },
          ],
        },
        {
          title: "Relatórios",
          show: permission("read", "reports"),
          iconClass: "fas fa-chart-bar",
          routes: [
            {
              routes: [
                {
                  name: "reports",
                  description: "Gerenciamento",
                  show: true,
                  iconClass: "fas fa-cogs",
                },
              ],
            },
          ],
        },
        {
          title: "Administrativo",
          show: permission("read", "graphics"),
          iconClass: "fas fa-th-list",
          routes: [
            {
              routes: [
                {
                  name: "graphics",
                  description: "Gráficos",
                  show: true,
                  iconClass: "fas fa-chart-line",
                },
              ],
            },
          ],
        },
        {
          title: "Importação",
          show: import_migrations,
          iconClass: "fas fa-cogs",
          routes: [
            {
              routes: [
                {
                  name: "import_residents",
                  description: "Importação de residente(s)",
                  show: true,
                  iconClass: "fas fa-file-import",
                },
                {
                  name: "import_users",
                  description: "Importação de usuários(s)",
                  show: true,
                  iconClass: "fas fa-file-import",
                },
              ],
            },
          ],
        },
        {
          title: "Configurar estoque 0.33",
          show: medicine_one_third,
          iconClass: "fas fa-list",
          routes: [
            {
              routes: [
                {
                  name: "medicine-one-third",
                  description: "Configurar",
                  show: true,
                  iconClass: "fas fa-list",
                },
              ],
            },
          ],
        },
        {
          title: "Financeiro",
          show: permission("read", "financial"),
          iconClass: "fas fa-piggy-bank",
          routes: [
            {
              routes: [
                {
                  name: "financial",
                  description: "Gerenciamento",
                  show: true,
                  iconClass: "fas fa-cogs",
                },
              ],
            },
          ],
        },
        {
          title: "Familiares",
          show: false,
          iconClass: "fas fa-list",
          routes: [
            {
              routes: [
                {
                  name: "family_residents",
                  description: "Residentes",
                  show: true,
                  iconClass: "fas fa-users",
                },
              ],
            },
          ],
        },
        {
          title: "Configurações",
          show:
            permission("read", "config_stock_config") ||
            permission("read", "config_advance_notification") ||
            permission("read", "config_nfe_change_name_item") ||
            permission("read", "config_home_care"),
          iconClass: "fas fa-cogs",
          routes: [
            {
              routes: [
                {
                  name: "stock-config",
                  description: "Estoque para separação/checagem",
                  show: permission("read", "config_stock_config"),
                  iconClass: "fas fa-box",
                },
                {
                  name: "advance-notification",
                  description: "Notificação antecipada para separação/checagem",
                  show: permission("read", "config_advance_notification"),
                  iconClass: "fas fa-envelope",
                },
                {
                  name: "nfe-change-name-item",
                  description:
                    "Importação de produtos da nota fiscal na compra",
                  show: permission("read", "config_nfe_change_name_item"),
                  iconClass: "fas fa-cogs",
                },
                {
                  name: "config-home-care",
                  description: "Home care / Família",
                  show: permission("read", "config_home_care"),
                  iconClass: "fas fa-cogs",
                },
              ],
            },
          ],
        },
        {
          title: "Estoque",
          show:
            permission("write", "rest_home_transfer_medicine_resident") ||
            (permission("read", "financial") &&
              permission("write", "main_stock_shopping")) ||
            permission("write", "rest_home_transfer_medicine_resident") ||
            permission("read", "readjustment_service") ||
            permission("read", "readjustment_type_of_hosting") ||
            permission("write", "main_stock_input") ||
            permission("write", "main_stock_transfer") ||
            permission("write", "main_stock_output") ||
            permission("read", "main_stock_reversal") ||
            permission("read", "product") ||
            permission("read", "medicine") ||
            permission("read", "stock") ||
            permission("read", "duty"),
          iconClass: "fas fa-box",
          routes: [
            {
              routes: [
                {
                  name: "new-stock",
                  description: "Gerenciar",
                  show: true,
                  iconClass: "fas fa-cogs",
                },
              ],
            },
          ],
        },
      ];

      let newRoutes = [];

      let routeName = routes.currentRoute.name;

      let key = 0;
      for (let item of routesItems) {
        if (item.show) {
          for (let k of item.routes) {
            for (let y of k.routes) {
              if (y.name == routeName) {
                this.route = routeName;
                this.current = key;
              }
            }
          }
          newRoutes.push(item);
        }
        key++;
      }

      this.routesItems = newRoutes;
    },

    handlePage(name) {
      this.route = name;
      if (routes.currentRoute.name !== name) {
        routes.push({ name });
      } else {
        this.sidebarIsVisible = false;
      }
    },

    handleToModules() {
      if (routes.currentRoute.name != "modules") {
        routes.push({ name: "modules" });
      }
    },

    handleToHelp() {
      if (routes.currentRoute.name != "help") {
        routes.push({ name: "help" });
      }
    },

    handleToAccount() {
      if (routes.currentRoute.name != "account") {
        routes.push({ name: "account" });
      }
    },

    handleDoc(docToRead) {
      this.docToRead = docToRead;

      this.$nextTick(() => {
        this.$bvModal.show(`ConfirmationReading-${this.docToRead.id}`);
      });
    },

    directToPrintViewBuy: (buy_id) => {
      let route = routes.resolve({
        name: "buy-print",
        params: {
          buy_id,
        },
      });

      window.open(route.href, "_blank");
    },

    reloadPage() {
      window.location.reload();
    },
  },
};
</script>

<style scoped>
/* Melhorias na Navbar Principal */
.navbartop {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1000;
}

.div-navbar-color {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%) !important;
  margin: 0 !important;
  padding: 8px 20px;
  min-height: 70px;
  align-items: center;
}

/* Botão do Menu Aprimorado */
.enhanced-menu-btn {
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.15) 0%,
    rgba(255, 255, 255, 0.1) 100%
  ) !important;
  border: 2px solid rgba(255, 255, 255, 0.2) !important;
  border-radius: 12px !important;
  width: 50px !important;
  height: 50px !important;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2) !important;
}

.enhanced-menu-btn:hover {
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.25) 0%,
    rgba(255, 255, 255, 0.15) 100%
  ) !important;
  border-color: rgba(255, 255, 255, 0.4) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3) !important;
}

.enhanced-menu-btn:active {
  transform: translateY(0) !important;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2) !important;
}

/* Nome da Clínica Aprimorado */
.enhanced-clinic-name {
  color: white !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  padding-left: 16px !important;
  cursor: pointer !important;
  display: flex !important;
  align-items: center !important;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3) !important;
  margin: 0 !important;
}

.enhanced-clinic-name:hover {
  color: #e0f2fe !important;
  transform: translateX(4px) !important;
  text-shadow: 0 3px 12px rgba(0, 0, 0, 0.4) !important;
}

/* Seção de Conta Aprimorada */
.enhanced-account-section {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-end !important;
  gap: 12px !important;
}

/* Alerta Offline Aprimorado */
.enhanced-offline-alert {
  color: #fff3cd !important;
  background: rgba(220, 53, 69, 0.2) !important;
  border: 1px solid rgba(220, 53, 69, 0.3) !important;
  border-radius: 8px !important;
  padding: 6px 12px !important;
  font-size: 11px !important;
  font-weight: 600 !important;
  text-align: center !important;
  margin: 0 !important;
  backdrop-filter: blur(5px) !important;
  animation: pulse-soft 2s infinite !important;
}

@keyframes pulse-soft {
  0%,
  100% {
    opacity: 0.8;
  }
  50% {
    opacity: 1;
  }
}

/* Botões de Ação Aprimorados */
.enhanced-help-btn,
.enhanced-update-btn {
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.15) 0%,
    rgba(255, 255, 255, 0.1) 100%
  ) !important;
  color: white !important;
  border: 2px solid rgba(255, 255, 255, 0.2) !important;
  backdrop-filter: blur(10px) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  text-transform: uppercase !important;
}

.enhanced-help-btn:hover,
.enhanced-update-btn:hover {
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.25) 0%,
    rgba(255, 255, 255, 0.15) 100%
  ) !important;
  border-color: rgba(255, 255, 255, 0.4) !important;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2) !important;
  color: white !important;
}

/* Container de Foto Aprimorado */
.enhanced-photo-container {
  width: 42px !important;
  height: 42px !important;
  border-radius: 21px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border: 3px solid white !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
  overflow: hidden !important;
  position: relative !important;
}

.enhanced-photo-container.online {
  border-color: #10b981 !important;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3) !important;
}

.enhanced-photo-container.offline {
  border-color: #ef4444 !important;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3) !important;
}

.enhanced-photo-container:hover {
  transform: scale(1.05) !important;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3) !important;
}

.enhanced-photo-container::after {
  content: "";
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid white;
}

.enhanced-photo-container.online::after {
  background: #10b981;
}

.enhanced-photo-container.offline::after {
  background: #ef4444;
}

/* Nome do Usuário Aprimorado */
.enhanced-user-name {
  color: white !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  margin: 0 8px 0 12px !important;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.3) !important;
}

.enhanced-user-name:hover {
  color: #e0f2fe !important;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.4) !important;
}

/* Dropdown de Notificação Aprimorado */
.enhanced-notification {
  position: relative !important;
}

.enhanced-notification-btn {
  width: 42px !important;
  height: 42px !important;
  border-radius: 50% !important;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.15) 0%,
    rgba(255, 255, 255, 0.1) 100%
  ) !important;
  border: 2px solid rgba(255, 255, 255, 0.2) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: white !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  text-decoration: none !important;
  position: relative !important;
}

.enhanced-notification-btn:hover {
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.25) 0%,
    rgba(255, 255, 255, 0.15) 100%
  ) !important;
  border-color: rgba(255, 255, 255, 0.4) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2) !important;
  color: white !important;
  text-decoration: none !important;
}

.enhanced-badge {
  position: absolute !important;
  top: -5px !important;
  right: -2px !important;
  width: 12px !important;
  height: 12px !important;
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
  border-radius: 50% !important;
  border: 2px solid white !important;
  box-shadow: 0 2px 6px rgba(239, 68, 68, 0.4) !important;
  animation: pulse-notification 2s infinite !important;
}

@keyframes pulse-notification {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

/* Menu de Notificação Aprimorado */
.enhanced-notification-menu {
  background: white !important;
  border: none !important;
  border-radius: 16px !important;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15) !important;
  padding: 0 !important;
  margin-top: 8px !important;
  min-width: 320px !important;
  max-width: 400px !important;
  backdrop-filter: blur(10px) !important;
  overflow: hidden !important;
}

.enhanced-notification-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;
  padding: 16px 20px !important;
  border-bottom: 1px solid #e5e7eb !important;
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
}

.enhanced-notification-header i {
  color: #0f65b0 !important;
  font-size: 18px !important;
}

.enhanced-notification-header .notification-title {
  font-weight: 600 !important;
  color: #1e293b !important;
  font-size: 16px !important;
}

.enhanced-notification-list {
  padding: 16px !important;
  max-height: 300px !important;
  overflow-y: auto !important;
}

.enhanced-notification-list .notification-list-label {
  font-size: 12px !important;
  color: #6b7280 !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  margin-bottom: 12px !important;
  display: block !important;
}

.enhanced-notification-item {
  background: #f8fafc !important;
  border: 1px solid #e5e7eb !important;
  border-radius: 12px !important;
  padding: 12px !important;
  margin-bottom: 8px !important;
  transition: all 0.3s ease !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 12px !important;
}

.enhanced-notification-item:hover {
  background: #f1f5f9 !important;
  border-color: #cbd5e1 !important;
  transform: translateX(2px) !important;
}

.enhanced-notification-item:last-child {
  margin-bottom: 0 !important;
}

.notification-doc-info {
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
}

.notification-doc-info-header {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.enhanced-notification-item .notification-doc-info {
  display: flex !important;
  align-items: flex-start !important;
  gap: 8px !important;
  flex: 1 !important;
  min-width: 0 !important;
}

.enhanced-notification-item .notification-doc-icon {
  color: #0f65b0 !important;
  font-size: 14px !important;
}

.enhanced-notification-item .notification-doc-name {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #374151 !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

.notification-doc-date {
  font-size: 10px;
  color: #6c757d;
  margin-top: 2px;
  text-align: left;
}

.enhanced-action-btn {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%) !important;
  border: none !important;
  border-radius: 8px !important;
  color: white !important;
  font-size: 11px !important;
  font-weight: 600 !important;
  padding: 6px 12px !important;
  transition: all 0.3s ease !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
}

.enhanced-action-btn:hover {
  background: linear-gradient(135deg, #1e40af 0%, #2563eb 100%) !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(15, 101, 176, 0.4) !important;
  color: white !important;
}

.enhanced-notification-empty {
  padding: 20px !important;
  text-align: center !important;
  color: #6b7280 !important;
  font-size: 14px !important;
}

/* Dropdown de Usuário Aprimorado */
.enhanced-user-dropdown {
  position: relative !important;
}

.enhanced-settings-btn {
  width: 20px !important;
  height: 20px !important;
  background: transparent !important;
  border: none !important;
  color: white !important;
  cursor: pointer !important;
  position: relative !important;
}

.enhanced-settings-btn:hover::before {
  color: #e0f2fe !important;
  transform: translateY(1px) !important;
}

.enhanced-user-menu {
  background: white !important;
  border: none !important;
  border-radius: 12px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;
  padding: 8px 0 !important;
  margin-top: 8px !important;
  min-width: 200px !important;
  backdrop-filter: blur(10px) !important;
  overflow: hidden !important;
}

.enhanced-user-item {
  padding: 12px 20px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #374151 !important;
  border: none !important;
  background: transparent !important;
  width: 100% !important;
  text-align: left !important;
  transition: all 0.3s ease !important;
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
}

.enhanced-user-item:hover {
  background: #f8fafc !important;
  color: #0f65b0 !important;
  transform: translateX(4px) !important;
}

.enhanced-user-item i {
  color: #6b7280 !important;
  font-size: 14px !important;
  transition: all 0.3s ease !important;
}

.enhanced-user-item:hover i {
  color: #0f65b0 !important;
}

.enhanced-logout {
  border-top: 1px solid #e5e7eb !important;
  margin-top: 8px !important;
  padding-top: 12px !important;
}

.enhanced-logout:hover {
  background: #fef2f2 !important;
  color: #dc2626 !important;
}

.enhanced-logout:hover i {
  color: #dc2626 !important;
}

/* Responsividade Aprimorada */
@media (max-width: 768px) {
  .div-navbar-color {
    padding: 6px 15px !important;
    min-height: 60px !important;
  }

  .enhanced-clinic-name {
    font-size: 16px !important;
    padding-left: 12px !important;
  }

  .enhanced-account-section {
    gap: 8px !important;
  }

  .enhanced-menu-btn {
    width: 44px !important;
    height: 44px !important;
  }

  .enhanced-photo-container {
    width: 36px !important;
    height: 36px !important;
  }

  .enhanced-notification-btn {
    width: 36px !important;
    height: 36px !important;
  }

  .enhanced-notification-btn i {
    font-size: 14px !important;
  }

  .enhanced-user-name {
    font-size: 12px !important;
    margin: 0 6px 0 8px !important;
  }
}

@media (max-width: 576px) {
  .enhanced-clinic-name {
    display: none !important;
  }

  .enhanced-user-name {
    display: none !important;
  }

  .enhanced-help-btn {
    padding: 6px 12px !important;
    font-size: 10px !important;
  }

  .enhanced-notification-menu {
    min-width: 280px !important;
    max-width: calc(100vw - 40px) !important;
  }
}

/* Scrollbar personalizada para menus */
.enhanced-notification-list::-webkit-scrollbar {
  width: 4px;
}

.enhanced-notification-list::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 2px;
}

.enhanced-notification-list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 2px;
}

.enhanced-notification-list::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Manter compatibilidade com estilos existentes */
.navbartop .system-update {
  height: 35px !important;
}

.navbartop .div-photo-url-top {
  width: 35px !important;
  height: 35px !important;
  border-radius: 17.5px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>